<template>
	<div>
		<div >
			<div class="pd30">
				<div>
					<flashsale-list :member_id="member_id"></flashsale-list>
				</div>
				<div class="mt20">
					<record-list :member_id="member_id"></record-list>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import flashsaleList from './flashsale/flashsalelist.vue';
	import recordList from './flashsale/recordlist.vue';
	export default{
		props:{
			member_id:{
				type:Number,
				default:0
			}
		},
		components:{
			flashsaleList,
			recordList,
		},
		data(){
			return{
				loading:false,
			}
		}
	}
</script>

<style>
</style>
